import {sendAuthenticatedUserConfigs, resetAuthenticatedUserConfigs} from './actions'

function authenticatedConfigsUpdated() {
    var configs

    return (state, dispatch) => {
        const nextConfigs = state.user.authenticatedConfigs

        if (nextConfigs != configs) {
        	if (configs && (nextConfigs.ticketOpenedNotifications != configs.ticketOpenedNotifications
                || nextConfigs.daybookNotifications != configs.daybookNotifications
                || nextConfigs.simplifiedRequestOpenedNotifications != configs.simplifiedRequestOpenedNotifications)) {
                const previousConfigs = configs
                
            	dispatch(sendAuthenticatedUserConfigs()).catch(() => {
                    configs = previousConfigs
                    dispatch(resetAuthenticatedUserConfigs(previousConfigs))
                })
            }
            configs = nextConfigs
        }
    }
}

export default [authenticatedConfigsUpdated()]


// WEBPACK FOOTER //
// ./lib/user/actors.js